import { TNullable } from '@common/types';

export enum ScrollSource {
  Page,
  Chapter,
  PageAndChapter,
  None,
}
export enum PDFReadingMode {
  SinglePage,
  ContinuousPage,
}

interface PDFScrollableElement {
  element: TNullable<HTMLElement>;
  type: ScrollSource.Page | ScrollSource.Chapter;
}
export async function scrollElementsInOrder(elements: PDFScrollableElement[]) {
  for (const scrollableElement of elements) {
    if (!scrollableElement.element) return;
    const { element, type } = scrollableElement;
    element.scrollIntoView({
      behavior: 'smooth',
      block: ScrollSource.Page === type ? 'start' : 'center',
    });

    // Wait for scroll to complete using scrollend event
    await new Promise<void>((resolve) => {
      const controller = new AbortController();
      let timeoutId: NodeJS.Timeout; // eslint-disable-line

      const cleanup = () => {
        window.removeEventListener('scrollend', onScrollEnd);
        clearTimeout(timeoutId);
        controller.abort();
      };

      const onScrollEnd = () => {
        cleanup();
        resolve();
      };

      // Listen for scrollend event
      window.addEventListener('scrollend', onScrollEnd, {
        signal: controller.signal,
      });

      // Fallback timeout in case scrollend doesn't fire
      timeoutId = setTimeout(() => {
        cleanup();
        resolve();
      }, 1000);
    });
  }
}
